<template>
  <div class="asd20-event-checkbox-list">
    <div
      v-for="option in options"
      :key="option.value"
      class="asd20-event-checkbox-list__item"
    >
      <div class="bullet-wrapper">
        <span
          v-if="option.color"
          :style="{ '--bullet-color': option.color }"
          class="coloredBullet"
          aria-hidden="true"
        />
        <!-- <span
          v-if="option.color"
          :style="{ 'color': option.color }"
          class="coloredBullet"
          aria-hidden="true"
          role="presentation">
          •
        </span> -->
        <asd20-checkbox
          :label="option.text"
          :count="option.count"
          :color="option.color"
          :description="option.description"
          :value="checkedValues.indexOf(option.value) > -1"
          @input="onInput($event, option)"
        />
        <slot
          :option="option"
          :value="checkedValues.indexOf(option.value) > -1"
          name="item"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Asd20Checkbox from '@asd20/ui/src/components/atoms/Asd20Checkbox'

export default {
  name: 'Asd20EventCheckboxList',
  components: { Asd20Checkbox },
  model: {
    prop: 'checkedValues',
  },
  props: {
    checkedValues: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
  },
  methods: {
    onInput(checked, option) {
      let modifiedCheckedValues = this.checkedValues.slice()

      if (checked) {
        modifiedCheckedValues.push(option.value)
      } else {
        modifiedCheckedValues = modifiedCheckedValues.filter(
          v => v !== option.value
        )
      }
      this.$emit('change', { option, checked })

      this.$emit('input', modifiedCheckedValues, option, checked)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@asd20/ui/src/design/_mixins.scss';
@import '@asd20/ui/src/design/_variables.scss';

.asd20-event-checkbox-list {
  &__item {
    border-bottom: 1px solid var(--color__tertiary);
    padding-top: space(0.25);
    padding-bottom: space(0.25);
    .bullet-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .coloredBullet::before {
        content: '•';
        color: var(--bullet-color);
        font-size: 3rem;
        line-height: 1rem;
        margin-left: 1.5rem;
        vertical-align: middle;
      }
    }

    &:last-child {
      border-bottom: none;
    }
    .asd20-checkbox label {
      font-weight: normal;
    }
  }
  .asd20-event-checkbox-list {
    background: var(--website-page__alternate-background-t60);
    margin-top: space(0.25);
    margin-bottom: space(-0.25);
    padding: space(0.5) space(0) space(0.5) space(1);
    border-top: 1px solid var(--color__tertiary);
  }
}
</style>
